'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/mcs-client/node_modules/core-js/internals/is-pure.js
// module id = 360
// module chunks = 25